module.exports = (__parcel__import__("7cxio")).then(() => parcelRequire('ahP7X'));